import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import moment from 'logic/moment';
import { Typography } from '@material-ui/core';

const headerProps = {
  component: 'h3',
  variant: 'h4',
};

const UserInfoWithNameHeader = (props) => {
  const { birthday, city, country, name, phone_1, phone_2 } = props;
  const intl = useIntl();

  return (
    <Typography component="div">
      {name && (
        <Typography {...headerProps}>
          {name === 'Deleted'
            ? intl.formatMessage({ id: 'Deleted', defaultMessage: 'Deleted' })
            : name}
        </Typography>
      )}
      {birthday && <div>{moment(birthday).format('LL')}</div>}
      {city && (
        <div>
          {city}
          {country && [', ', country]}
        </div>
      )}
      {phone_1 && <div>{phone_1}</div>}
      {phone_2 && <div>{phone_2}</div>}
    </Typography>
  );
};

UserInfoWithNameHeader.propTypes = {
  birthday: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  city: PropTypes.string,
  country: PropTypes.string,
  name: PropTypes.string,
  phone_1: PropTypes.string,
  phone_2: PropTypes.string,
  isNameHeader: PropTypes.bool,
};

const UserInfo = (props) => {
  const { birthday, city, country, name, phone_1, phone_2, isNameHeader, hidePhone } = props;
  const intl = useIntl();

  if (isNameHeader) {
    return <UserInfoWithNameHeader {...props} />;
  }

  return (
    <Typography component="div">
      {name && (
        <div>
          {name === 'Deleted'
            ? intl.formatMessage({ id: 'Deleted', defaultMessage: 'Deleted' })
            : name}
        </div>
      )}
      {birthday && <div>{moment(birthday).format('LL')}</div>}
      {city && (
        <div>
          {city}
          {country && [', ', country]}
        </div>
      )}
      {phone_1 && !hidePhone && <div>{phone_1}</div>}
      {phone_2 && !hidePhone && <div>{phone_2}</div>}
    </Typography>
  );
};

UserInfo.propTypes = {
  birthday: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  city: PropTypes.string,
  country: PropTypes.string,
  name: PropTypes.string,
  phone_1: PropTypes.string,
  phone_2: PropTypes.string,
  isNameHeader: PropTypes.bool,
  hidePhone: PropTypes.bool,
};

export default UserInfo;
